import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';
import logo from '@/assets/footer/logo-white_01.png';
import { getChildrenToRenderWithoutTrans } from '@/utils';
import { isImg } from '@/utils';
import { withTranslation } from 'react-i18next';

class Footer extends React.Component {

  static defaultProps = {
    className: 'footer1',
  };

  getLiChildren = (data) =>
    data.map((item, i) => {
      const { title, childWrapper, ...itemProps } = item;
      const isMobile = this.props.isMobile;
      const { t } = this.props;
      if (i < 4) {
        return (
          <Col key={i.toString()} {...itemProps} title={null} content={null}>
            <h2 {...title}>
              {typeof title.children === 'string' &&
              title.children.match(isImg) ? (
                <img src={logo} width="100%" alt="img" />
              ) : (
                t(title.children)
              )}
            </h2>
            <div {...childWrapper}>
              {childWrapper.children.map((value, index) => getChildrenToRenderWithoutTrans(value, index, t))}
            </div>
          </Col>
        );
      } else {
        return (
          <Col key={i.toString()} {...itemProps} title={null} content={null}>
            {
              isMobile && (
                <h2 {...title}>
                  {t(title.children)}
                </h2>
              )
            }

            {/*<div {...childWrapper}>*/}
            {childWrapper.children.map((value, index) => getChildrenToRenderWithoutTrans(value, index, t))}
            {/*</div>*/}
            {
              !isMobile && (
                <h2 {...title}>
                  {t(title.children)}
                </h2>
              )
            }
          </Col>
        );
      }

    });

  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    const { t } = props;
    delete props.dataSource;
    delete props.isMobile;
    const childrenToRender = this.getLiChildren(dataSource.block.children);
    return (
      <footer {...props} {...dataSource.wrapper}>
        <OverPack {...dataSource.OverPack}>
          <QueueAnim
            type="bottom"
            key="ul"
            leaveReverse
            component={Row}
            {...dataSource.block}
          >
            {childrenToRender}
          </QueueAnim>
          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from' }}
            key="copyright"
            {...dataSource.copyrightWrapper}
          >
            <div {...dataSource.copyrightPage}>
              <div {...dataSource.copyright}>
                <span>
                  {t(dataSource.copyright.children)}
                  <a href={'https://beian.miit.gov.cn/'}
                     rel={'external nofollow noreferrer'}
                     target={'_blank'}>沪ICP备17041393号-2</a>
                </span>
              </div>
            </div>
          </TweenOne>
        </OverPack>
      </footer>
    );
  }
}

export default withTranslation()(Footer);
